export const WORKSPACE_ROUTE_PREFIX = '/workspace';

export const getWorkspacePath = (workspaceId: string): string =>
  `${WORKSPACE_ROUTE_PREFIX}/${workspaceId}`;

export const isWorkspaceHomePath = (pathname: string): boolean =>
  pathname === WORKSPACE_ROUTE_PREFIX
  || pathname.startsWith(`${WORKSPACE_ROUTE_PREFIX}/`);
